import { isPrimaryContribution } from "lib/contributions";
import { AuthorSerializersContribution } from "types/serializers";

export interface Props {
  contributions: AuthorSerializersContribution[];
  className?: string;
  all?: boolean;
}

const ContributionsListText = ({
  className = "",
  contributions,
  all = false,
}: Props) => {
  if (!contributions || contributions.length === 0) {
    return <></>;
  }

  return (
    <ul className="list-comma">
      {contributions
        .filter((contribution) => all || isPrimaryContribution(contribution))
        .map((contribution) => (
          <li
            key={`contribution-${contribution.author.slug}`}
            className={className}
          >
            {contribution.author.name}
            {contribution.contribution && (
              <span className="font-normal text-sm">
                {" "}
                ({contribution.contribution})
              </span>
            )}
          </li>
        ))}
    </ul>
  );
};

export default ContributionsListText;
